import { Fragment } from "react";

import { define } from "@/components/builder/utils";

import { FormFieldProvider } from "./context";

import { customFields, fields } from ".";

function FormFieldWrapperPreview({ field }) {
  let FieldComponent = fields[field.field]

  if (!FieldComponent) {
    FieldComponent = customFields[field.field_component]
  }

  return <>
    <FormFieldProvider field={field}>
      {FieldComponent && <FieldComponent />}
    </FormFieldProvider>
  </>
}

export default define('form-field-wrapper', FormFieldWrapperPreview, Fragment)
  .build()

